import { DefaultTheme } from 'styled-components';

export const lightTheme: DefaultTheme = {
  main1: {
    main1: 'rgb(97, 96, 154)',
    main2: 'rgb(201, 66, 69)',
    side: 'rgb(248, 193, 186)',
  },
  main2: {
    main1: 'rgb(167, 181, 204)',
    main2: 'rgb(133, 132, 189)',
    side: 'rgb(244, 237, 54)',
  },
  main3: {
    main1: 'rgb(181, 201, 149)',
    main2: 'rgb(249, 204, 115)',
    side: 'rgb(172, 79, 152)',
  },
  main4: {
    main1: 'rgb(248, 193, 186)',
    side: 'rgb(55, 80, 39)',
  },
  black: {
    veryDark: 'rgb(26, 26, 26)',
    darker: '#2f2f2f',
    lighter: '#3a3a3a',
  },
  white: {
    veryDark: '#e3cc9f',
    lighter: '#fff',
    darker: '#fcf8f1',
  },
  title: 'Titan One, Jua',
  padding: {
    lg: '1rem 2rem',
    md: '0.8rem 1rem',
    sm: '0 1rem 0.5rem',
  },
  sideMenu: {
    lg: '300px',
    md: '270px',
    sm: '220px',
    xs: '80px',
  },
  boxLine: {
    lg: '3px solid rgb(26, 26, 26)',
    md: '2.5px solid rgb(26, 26, 26)',
    sm: '2px solid rgb(26, 26, 26)',
  },
  background: '#fff',
};
